import { Box, styled } from "@mui/material";
import { MiscSavio, StyleguideSavioColors, StyleguideSavioFonts } from "../../configuration/themeSettings";

export const BoxRoot = styled(Box, {
  label: "app-custom-tab-panel-box-root",
})(({ theme }) => ({


  "> .MuiBox-root": {
    padding: 0,
    textAlign: "left"
  },
  ".MuiList-root": {
    padding: 0,
    //maxHeight: 600,
    //height: 'calc(100vh - 600px)',
    overflow: 'hidden',
    overflowY: 'auto',
  },
  ".MuiListItem-root": {
    paddingLeft: 20,
    paddingRight: 20,
    borderColor: theme.palette.divider,

    "&:last-child": {
      borderBottom: 0,
    },

    "> a": {
      color: theme.palette.primary.main,
      opacity: 0,
      transitionProperty: "opacity",
      transitionDuration: "0.4s",
      display: "flex",
      alignItems: 'center',
      marginRight: 15,
      "&:last-child": {
        marginRight: 0,
      },
    },



    "&:not(.selected):hover": {

      "> a": {

        opacity: 1
      },


      "*": { textDecoration: 'underline', },
      "&:before": {
        display: 'block',
        content: "''",
        width: 3,
        height: '100%',
        backgroundColor: StyleguideSavioColors.blue,
        left: 0,
        position: 'absolute',
        zIndex: 1,

      },

    }


  },
  ".MuiListItemText-root": {
    ">p": {
      fontSize: 12,
      color: StyleguideSavioColors.text.black,
    },
    "> p:first-of-type": {
      fontWeight: StyleguideSavioFonts.bold,
      color: theme.palette.primary.main,
    },

    "&:hover": {

      ">p": {
        //textDecoration: "underline",
        color: StyleguideSavioColors.text.black,
      },
      "> p:first-of-type": {
        //textDecoration: "underline",
        color: MiscSavio.hoverColor,
      },
    }
  }
}));

